import { ContentNode } from '@dreryk/react-components';

import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';
import { appointmentsTranslationKeys } from '../../../../../translations';

export const getWarningMessage = (
   previousTotalAdvancePayment: number,
   currentTotalAdvancePayment: number
): ContentNode | null => {
   if (previousTotalAdvancePayment === currentTotalAdvancePayment) {
      return null;
   }

   return appointmentsTranslationKeys.receptionServicesHaveBeenChangedAdvancePaymentMayRequiredAnAdditionalPaymentOrRefund;
};

export const getTotalAdvancePayment = (receptionServiceValue: ReceptionServiceTableBean[]): number => {
   return receptionServiceValue.reduce(
      (acc, { receptionService }) => acc + (receptionService.advancePaymentValue?.asNumber() ?? 0),
      0
   );
};
